/**
 * The words under every new-password field (`PasswordStrength`, @tonnie/ui):
 * the rule, the advice and the four strength levels — translated once here.
 *
 *   <PasswordStrength labels={usePasswordStrengthLabels()} … />
 */
import { useMemo } from 'react';

import { useTranslation } from './useTranslation';

export interface PasswordStrengthLabels {
  requirement: string;
  advice: string;
  levels: { weak: string; fair: string; good: string; strong: string };
}

export function usePasswordStrengthLabels(): PasswordStrengthLabels {
  const { t } = useTranslation();
  return useMemo(
    () => ({
      requirement: t('auth.passwordRule.length'),
      advice: t('auth.passwordRule.advice'),
      levels: {
        weak: t('auth.passwordRule.levels.weak'),
        fair: t('auth.passwordRule.levels.fair'),
        good: t('auth.passwordRule.levels.good'),
        strong: t('auth.passwordRule.levels.strong'),
      },
    }),
    [t]
  );
}
